import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { MdOutlineFreeCancellation } from "react-icons/md";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const SponsorshipMembership = ({
  setPercent,
  isFieldRequired,
  initialValues,
  bindField,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });

  const referralCodePath = "additionalInfo.referralCode";
  const referralCodeField = bindField(referralCodePath, {
    label: SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.REFERRAL.LABEL,
    required: isFieldRequired(referralCodePath),
    onBlur: () => setPercent(initialValues),
  });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.SPONSORSHIP_MEMBERSHIP}-section`}
    >
      <Form
        type="vertical"
        title={
          SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.SPONSORSHIP_MEMBERSHIP.TITLE
        }
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <FormField
              path={referralCodeField.path}
              label={referralCodeField.label}
              required={referralCodeField.required}
              disabled={referralCodeField.disabled}
            >
              {(field) => (
                <Input
                  optional={SUBSCRIPTION.FORM.OPTIONAL}
                  placeholder={
                    SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.REFERRAL.PLACEHOLDER
                  }
                  label={referralCodeField.label}
                  icon={<MdOutlineFreeCancellation size={16} />}
                  defaultValue={referralCodeField.defaultValue}
                  {...field}
                  onChange={referralCodeField.onChange}
                  onBlur={referralCodeField.onBlur}
                />
              )}
            </FormField>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SponsorshipMembership;
